var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    fill: "none",
    viewBox: "0 0 16.5 16.5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "path1",
    d: "m6.6943 12.639c3.2829 0 5.9443-2.6614 5.9443-5.9443 0-3.283-2.6614-5.9443-5.9443-5.9443-3.283 0-5.9443 2.6614-5.9443 5.9443 0 3.2829 2.6614 5.9443 5.9443 5.9443z",
    stroke: "#616e8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path2",
    d: "m15.75 15.75-4.6692-4.6692",
    stroke: "#616e8d",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.c468d2ba2e3eaa0222fb00581f74eec8.svg";
export { ForwardRef as ReactComponent };